<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>
<!--p-blockUI [target]="pnl" [blocked]="blocked">
    <i class="pi pi-lock" style="font-size: 4rem"></i>
</p-blockUI-->

<div class="card">
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="Regresar" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
                (click)="goBack()"></button>
            <button pButton pRipple label="Agregar" icon="pi pi-plus" class="p-button-success p-mr-2"
                (click)="openNew()"></button>
            <!--button pButton pRipple [label]="Delete" icon="pi pi-trash" class="p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedProducts || !selectedProducts.length"></button-->
        </ng-template>

        <!--ng-template pTemplate="right">
            <p-fileUpload mode="basic" accept="image/*" [maxFileSize]="1000000" label="Import" chooseLabel="Import" class="p-mr-2 p-d-inline-block"></p-fileUpload>
            <button pButton pRipple label="Export" icon="pi pi-upload" class="p-button-help"></button>
        </ng-template-->
    </p-toolbar>
    <p-table #dt [value]="lstAuthOpts" [(selection)]="selectedAuthOpts" dataKey="id" styleClass="p-datatable-customers"
        [rowHover]="true" [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]"
        [loading]="loading" [paginator]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [filterDelay]="0"
        [globalFilterFields]="['name','country.name','representative.name','status']">
        <ng-template pTemplate="caption">
            <div class="table-header">
                List of Auth Documents
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Global Search" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <!--th pSortableColumn="name">
                    <div class="p-d-flex p-jc-between p-ai-center">
                        Id
                        <p-sortIcon field="name"></p-sortIcon>
                        <p-columnFilter type="text" field="name" display="menu" class="p-ml-auto"></p-columnFilter>
                    </div>
                </th-->
                <th pSortableColumn="guideId">
                    <div class="p-d-flex p-jc-between p-ai-center">
                        GuideId
                    </div>
                </th>
                <th pSortableColumn="country.name">
                    <div class="p-d-flex p-jc-between p-ai-center">
                        Transacción Id
                    </div>
                </th>

                <th pSortableColumn="date">
                    <div class="p-d-flex p-jc-between p-ai-center">
                        Coordinador
                    </div>
                </th>
                <th pSortableColumn="date">
                    <div class="p-d-flex p-jc-between p-ai-center">
                        Secretario
                    </div>
                </th>
                <th pSortableColumn="balance">
                    <div class="p-d-flex p-jc-between p-ai-center">
                        Tesorero
                    </div>
                </th>
                <th pSortableColumn="balance">
                    <div class="p-d-flex p-jc-between p-ai-center">
                        Materiales
                    </div>
                </th>
                <th pSortableColumn="balance">
                    <div class="p-d-flex p-jc-between p-ai-center">
                        Jovenes
                    </div>
                </th>
                <th pSortableColumn="balance">
                    <div class="p-d-flex p-jc-between p-ai-center">
                        Escuela PG
                    </div>
                </th>
                <th pSortableColumn="balance">
                    <div class="p-d-flex p-jc-between p-ai-center">
                        Provedor
                    </div>
                </th>
                <th pSortableColumn="balance">
                    <div class="p-d-flex p-jc-between p-ai-center">
                        Zona
                    </div>
                </th>
                <th pSortableColumn="balance">
                    <div class="p-d-flex p-jc-between p-ai-center">
                        Nacional
                    </div>
                </th>
                <th pSortableColumn="balance">
                    <div class="p-d-flex p-jc-between p-ai-center">
                        Local
                    </div>
                </th>
                <th pSortableColumn="onMaint">
                    <div class="p-d-flex p-jc-between p-ai-center">
                        Mantenimiento
                    </div>
                </th>
                <th pSortableColumn="balance">
                    <div class="p-d-flex p-jc-between p-ai-center">
                        StoreId
                        <!--p-sortIcon field="balance"></p-sortIcon>
                        <p-columnFilter type="numeric" field="balance" display="menu" currency="USD" class="p-ml-auto"></p-columnFilter-->
                    </div>
                </th>


                <th style="width: 8rem">
                    <div class="p-d-flex p-jc-between p-ai-center">
                        Editar
                    </div>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-document>
            <tr class="p-selectable-row">
                <!--td>
                    <span class="p-column-title">Id</span>
                    {{document.id}}
                </td-->
                <td>
                    {{document.guideId}}
                </td>
                <td>
                    <span class="p-column-title">Transacción</span>
                    {{document.transactionId}}
                </td>
                <td>
                    <span class="p-column-title">Coordinador</span>
                    <button pButton pRipple type="button" icon="pi pi-check" class="p-button-rounded p-button-text"
                        *ngIf="document.coordinator == '1'"></button>
                    <button pButton pRipple type="button" icon="pi pi-times"
                        class="p-button-rounded p-button-danger p-button-text"
                        *ngIf="document.coordinator == '0'"></button>
                </td>
                <td>
                    <span class="p-column-title">Secretario</span>
                    <button pButton pRipple type="button" icon="pi pi-check" class="p-button-rounded p-button-text"
                        *ngIf="document.secretary == '1'"></button>
                    <button pButton pRipple type="button" icon="pi pi-times"
                        class="p-button-rounded p-button-danger p-button-text"
                        *ngIf="document.secretary == '0'"></button>
                </td>
                <td>
                    <span class="p-column-title">Tesorero</span>
                    <button pButton pRipple type="button" icon="pi pi-check" class="p-button-rounded p-button-text"
                        *ngIf="document.treasurer == '1'"></button>
                    <button pButton pRipple type="button" icon="pi pi-times"
                        class="p-button-rounded p-button-danger p-button-text"
                        *ngIf="document.treasurer == '0'"></button>
                </td>
                <td>
                    <span class="p-column-title">Materiales</span>
                    <button pButton pRipple type="button" icon="pi pi-check" class="p-button-rounded p-button-text"
                        *ngIf="document.materials == '1'"></button>
                    <button pButton pRipple type="button" icon="pi pi-times"
                        class="p-button-rounded p-button-danger p-button-text"
                        *ngIf="document.materials == '0'"></button>
                </td>
                <td>
                    <span class="p-column-title">Jovenes</span>
                    <button pButton pRipple type="button" icon="pi pi-check" class="p-button-rounded p-button-text"
                        *ngIf="document.youngs == '1'"></button>
                    <button pButton pRipple type="button" icon="pi pi-times"
                        class="p-button-rounded p-button-danger p-button-text" *ngIf="document.youngs == '0'"></button>
                </td>
                <td>
                    <span class="p-column-title">Escuela PG</span>
                    <button pButton pRipple type="button" icon="pi pi-check" class="p-button-rounded p-button-text"
                        *ngIf="document.schoolPG == '1'"></button>
                    <button pButton pRipple type="button" icon="pi pi-times"
                        class="p-button-rounded p-button-danger p-button-text"
                        *ngIf="document.schoolPG == '0'"></button>
                </td>
                <td>
                    <span class="p-column-title">Provedor</span>
                    <button pButton pRipple type="button" icon="pi pi-check" class="p-button-rounded p-button-text"
                        *ngIf="document.suppliers == '1'"></button>
                    <button pButton pRipple type="button" icon="pi pi-times"
                        class="p-button-rounded p-button-danger p-button-text"
                        *ngIf="document.suppliers == '0'"></button>
                </td>
                <td>
                    <span class="p-column-title">Zona</span>
                    <button pButton pRipple type="button" icon="pi pi-check" class="p-button-rounded p-button-text"
                        *ngIf="document.zoneLevel == '1'"></button>
                    <button pButton pRipple type="button" icon="pi pi-times"
                        class="p-button-rounded p-button-danger p-button-text"
                        *ngIf="document.zoneLevel == '0'"></button>
                </td>
                <td>
                    <span class="p-column-title">Nacional</span>
                    <button pButton pRipple type="button" icon="pi pi-check" class="p-button-rounded p-button-text"
                        *ngIf="document.natioLevel == '1'"></button>
                    <button pButton pRipple type="button" icon="pi pi-times"
                        class="p-button-rounded p-button-danger p-button-text"
                        *ngIf="document.natioLevel == '0'"></button>
                </td>
                <td>
                    <span class="p-column-title">Local</span>
                    <button pButton pRipple type="button" icon="pi pi-check" class="p-button-rounded p-button-text"
                        *ngIf="document.localLevel == '1'"></button>
                    <button pButton pRipple type="button" icon="pi pi-times"
                        class="p-button-rounded p-button-danger p-button-text"
                        *ngIf="document.localLevel == '0'"></button>
                </td>
                <td>
                    <span class="p-column-title">Mantenimiento</span>
                    <button pButton pRipple type="button" icon="pi pi-check" class="p-button-rounded p-button-text"
                        *ngIf="document.onMaint == '1'"></button>
                    <button pButton pRipple type="button" icon="pi pi-times"
                        class="p-button-rounded p-button-danger p-button-text"
                        *ngIf="document.onMaint == '0'"></button>
                </td>
                
                <td>
                    {{document.storeId}}
                </td>


                <td style="text-align: center">
                    <button type="button" pButton pRipple icon="pi pi-pencil"
                        class="p-button-rounded p-button-success mr-2" (click)="editDocument(document)"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="8">No document found.</td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-dialog [(visible)]="documentDialog" [style]="{width: '450px'}" header="Detalle Documento" [modal]="true"
    styleClass="p-fluid">
    <ng-template pTemplate="content">
        <div class="p-field">
            <label for="name">Transacción</label>
            <input type="text" pInputText id="name" [(ngModel)]="documentAuthOpts.transactionId" required autofocus />
            <small class="p-error" *ngIf="submitted && !documentAuthOpts.transactionId">Requerido</small>
        </div>
        <div class="p-field-radiobutton p-col-4">
            <p-inputSwitch [(ngModel)]="nvLAllGuides"></p-inputSwitch>
            <label for="allGuides">Todos los Guias</label>
        </div>


        <div class="p-field">
            <label class="p-mb-3">Función</label>
            <div class="p-formgrid p-grid">
                <div class="p-field-radiobutton p-col-4">
                    <p-inputSwitch [(ngModel)]="fctnCoord"></p-inputSwitch>
                    <label for="price">Coordinador </label>
                </div>
                <div class="p-field-radiobutton p-col-4">
                    <p-inputSwitch [(ngModel)]="fctnSecretary"></p-inputSwitch>
                    <label for="category2">Secretario</label>
                </div>
                <div class="p-field-radiobutton p-col-4">
                    <p-inputSwitch [(ngModel)]="fctnTreasure"></p-inputSwitch>
                    <label for="category3">Tesorero</label>
                </div>
            </div>
            <div class="p-formgrid p-grid">
                <div class="p-field-radiobutton p-col-4">
                    <p-inputSwitch [(ngModel)]="fctnMaterial"></p-inputSwitch>
                    <label for="price">Materiales </label>
                </div>
                <div class="p-field-radiobutton p-col-4">
                    <p-inputSwitch [(ngModel)]="fctnYoungs"></p-inputSwitch>
                    <label for="category2">Jovenes</label>
                </div>
                <div class="p-field-radiobutton p-col-4">
                    <p-inputSwitch [(ngModel)]="fctnschoolPG"></p-inputSwitch>
                    <label for="category3">Escuela PG</label>
                </div>
            </div>
        </div>
        <div class="p-field">
            <label for="name">Guide Id</label>
            <input type="text" pInputText id="name" [(ngModel)]="documentAuthOpts.guideId" />            
        </div>
        <div class="p-field">
            <label for="name">Store Id</label>
            <input type="text" pInputText id="name" [(ngModel)]="documentAuthOpts.storeId"
                [disabled]="disabledStoreId" />            
        </div>
        <div class="p-field">
            <label class="p-mb-3">Nivel</label>
            <div class="p-formgrid p-grid">
                <div class="p-field-radiobutton p-col-4">
                    <p-inputSwitch [(ngModel)]="nvlSupplier"></p-inputSwitch>
                    <label for="price">Proveedor </label>
                </div>
                <div class="p-field-radiobutton p-col-4">
                    <p-inputSwitch [(ngModel)]="nvlZonal"></p-inputSwitch>
                    <label for="category2">Zonal</label>
                </div>
                <div class="p-field-radiobutton p-col-4">
                    <p-inputSwitch [(ngModel)]="nvlNational"></p-inputSwitch>
                    <label for="category3">Nacional</label>
                </div>
            </div>
            <div class="p-formgrid p-grid">
                <div class="p-field-radiobutton p-col-4">
                    <p-inputSwitch [(ngModel)]="nvlLocal"></p-inputSwitch>
                    <label for="price">Local </label>
                </div>
                <div class="p-field-radiobutton p-col-4">
                    <p-inputSwitch [(ngModel)]="onMant"></p-inputSwitch>
                    <label for="price">Mantenimiento </label>
                </div>
            </div>
        </div>

    </ng-template>

    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
        <button pButton pRipple label="Save" icon="pi pi-check" class="p-button-text" (click)="saveDocument()"></button>
    </ng-template>
</p-dialog>